import React from 'react';
import { Logo } from './Logo';

export const Footer = ({ t }) => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-white border-t border-gray-200 py-20">
      <div className="container mx-auto px-8 max-w-6xl">
        <div className="grid md:grid-cols-2 gap-16 mb-16">
          <div>
            <Logo className="mb-8" />
            <p className="text-gray-600 font-light leading-relaxed max-w-md text-sm">
              {t.footer.description}
            </p>
          </div>

          <div className="grid grid-cols-2 gap-12">
            <div>
              <h3 className="text-gray-900 text-xs tracking-wider uppercase mb-8 font-medium">{t.footer.navigation}</h3>
              <ul className="space-y-4">
                <li>
                  <button
                    onClick={() => scrollToSection('services')}
                    className="text-gray-600 hover:text-gray-900 transition-colors font-light text-sm"
                  >
                    {t.footer.links.services}
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection('method')}
                    className="text-gray-600 hover:text-gray-900 transition-colors font-light text-sm"
                  >
                    {t.footer.links.method}
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection('contact')}
                    className="text-gray-600 hover:text-gray-900 transition-colors font-light text-sm"
                  >
                    {t.footer.links.consultation}
                  </button>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-gray-900 text-xs tracking-wider uppercase mb-8 font-medium">{t.footer.legal}</h3>
              <ul className="space-y-4">
                <li>
                  <a href="#" className="text-gray-600 hover:text-gray-900 transition-colors font-light text-sm">
                    {t.footer.links.privacy}
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-600 hover:text-gray-900 transition-colors font-light text-sm">
                    {t.footer.links.terms}
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-600 hover:text-gray-900 transition-colors font-light text-sm">
                    {t.footer.links.confidentiality}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <p className="text-gray-500 text-sm font-light">
              {t.footer.copyright}
            </p>
            <p className="text-gray-600 text-sm font-light tracking-wide">
              {t.footer.guarantee}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
